import * as THREE from 'three';
import {BUILDING_STRIDE,compileAsset,type CompiledAsset,type ProceduralAssetV1} from '@hyperlight/shared';
import {frontierForRecord,frontierLocal,frontierSupport,recordFrame,type FrontierRecord} from '../../../../shared/src/worldgen/frontierBuildings';
import {frontierTownView} from './frontierTownView';
// Only immutable, bounded production templates are cached. Lab edits compile afresh.
const artwork=new WeakMap<ProceduralAssetV1,CompiledAsset>();
/** One region-wide material/geometry batch, never a draw per cottage/roof tile. */
export function frontierBuildingsView(buildings:Float64Array):THREE.Group {
 const records=new Map<string,{o:number;f:FrontierRecord}>();
 for(let o=0;o<buildings.length;o+=BUILDING_STRIDE){const f=frontierForRecord(buildings,o);if(f)records.set(String(o),{o,f});}
 const view=frontierTownView({seed:'streamed-frontier',promenade:[],places:[...records].map(([id,{f}])=>({id,plan:f.plan,position:[0,0,0],quarterTurn:0}))},{
  inspectableIds:new Set(),
  compile(asset){let result=artwork.get(asset);if(!result){result=compileAsset(asset);artwork.set(asset,result);}return result;},
  transformForPlace(place,out){
   const {o,f}=records.get(place.id)!,frame=recordFrame(buildings,o);
   const p=frame.point(frontierLocal(f,[0,0,0]));
   const x=frame.point(frontierLocal(f,[1,0,0])),y=frame.point(frontierLocal(f,[0,1,0])),z=frame.point(frontierLocal(f,[0,0,1]));
   out.makeBasis(new THREE.Vector3().fromArray(x).sub(new THREE.Vector3().fromArray(p)),new THREE.Vector3().fromArray(y).sub(new THREE.Vector3().fromArray(p)),new THREE.Vector3().fromArray(z).sub(new THREE.Vector3().fromArray(p)));
   out.setPosition(...p);
  },
 });
 view.group.name='settlement-frontier-buildings';view.group.userData.buildings=records.size;
 const foundations:THREE.Matrix4[]=[];
 for(const {o,f} of records.values()){
  const frame=recordFrame(buildings,o),basis=new THREE.Matrix4().makeBasis(new THREE.Vector3().fromArray(frame.width),new THREE.Vector3().fromArray(frame.up),new THREE.Vector3().fromArray(frame.depth));
  for(const box of frontierSupport(f)){const m=basis.clone().scale(new THREE.Vector3().fromArray(box.size));m.setPosition(...frame.point(box.center));foundations.push(m);}
 }
 if(foundations.length){
  const mesh=new THREE.InstancedMesh(new THREE.BoxGeometry(1,1,1),new THREE.MeshStandardMaterial({color:0xc0b499,roughness:1}),foundations.length);
  foundations.forEach((m,i)=>mesh.setMatrixAt(i,m));mesh.computeBoundingSphere();mesh.castShadow=mesh.receiveShadow=true;mesh.userData.footstepSurface='stone';view.group.add(mesh);
 }
 return view.group;
}
